<template>
    <header class="header-wrapper">
        <div class="header">
            <div class="left">
                <router-link class="nav-item" to="/home">
                    <img src="../assets/logo.png" srcset="../assets/logo@2x.png 2x,img/logo@3x.png 3x" class="logo">
                </router-link>
            </div>
            <div class="right">
                <p class="phone">
                    <img src="../assets/icn-call.png" srcset="../assets/icn-call@2x.png 2x,img/icn-call@3x.png 3x" class="icn_call">
                    <span>客服热线: 010-53512690</span>
                </p>
                <div class="nav">
                    <router-link class="nav-item" to="/home">
                        <p>首页</p>
                    </router-link>
                    <router-link class="nav-item" to="/mizhi">
                        <p>幂之</p>
                        <p>金融数据平台</p>
                    </router-link>
                    <router-link class="nav-item" to="/baizhi">
                        <p>百智</p>
                        <p>债券风险管理BI平台</p>
                    </router-link>
                    <router-link class="nav-item" to="/huiyu">
                        <p>慧舆</p>
                        <p>定制化舆情跟踪系统</p>
                    </router-link>
                    <router-link class="nav-item" to="/qiancai">
                        <p>千采</p>
                        <p>报价平台</p>
                    </router-link>
                    <router-link class="nav-item" to="/liangtang">
                        <p>量堂</p>
                        <p>智能量化回测平台</p>
                    </router-link>
                    <router-link class="nav-item" to="/jiuzhang">
                        <p>九章</p>
                        <p>研究院</p>
                    </router-link>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

export default {
    name: "Header"
}
</script>
<style lang="scss">
.header-wrapper{
    width: 100%;
    height: 110px;
    .header{
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left{
            img.logo {
                width: 85px;
                height: 79px;
                margin-top: 16px;
                object-fit: contain;
            }
        }
        .right{
            .phone{
                text-align: right;
                margin: 0;
                margin-top:11px;
                margin-bottom: 23px;
                img.icn_call {
                    width: 16px;
                    height: 16px;
                    margin-right:6px;
                    object-fit: contain;
                    vertical-align: middle;
                }
                span{
                    font-size: 13px;
                    color: #bbb;
                    vertical-align: middle;
                }
                
            }
            .nav{
                display: flex;
                .nav-item{
                    display: inline-block;
                    text-decoration: none;
                    border-left: solid 1px #c0c0c0;
                    padding-left:12px;
                    padding-right: 12px;
                    width: 120px;
                    p:nth-child(1){
                        font-size: 18px;
                        color: #3a3a3a;
                        margin-bottom: 7px;
                    }
                    p:nth-child(2){
                        font-size: 13px;
                        color: #666;
                    }
                }
                .nav-item:nth-child(1){
                    width: 50px;
                    border-left: none;
                }
                .nav-item:nth-child(7){
                    width: 40px;
                    padding-right: 0;
                }
                .nav-item.router-link-active{
                    p{
                        color: #064ec1;
                    }
                }
            }
        }
    }
}

</style>